module.exports = __webpack_public_path__ + "img/logo-ecole.453ac12c.png";